import api, { ApiResponse } from './api';

export interface Site {
  id: number;
  siteID?: number;
  name: string;
  code?: string;
  address?: string;
  city?: string;
  isActive: boolean;
}

export interface SiteDropdownItem {
  id: number;
  name: string;
  code?: string;
}

export interface SiteCreateDto {
  name: string;
  code?: string;
  address?: string;
  city?: string;
}

export interface SiteUpdateDto {
  name?: string;
  code?: string;
  address?: string;
  city?: string;
  isActive?: boolean;
}

const siteService = {
  getAll: async (activeOnly: boolean = false): Promise<ApiResponse<Site[]>> => {
    const params = activeOnly ? '?activeOnly=true' : '';
    return api.get(`/sites${params}`);
  },

  getDropdown: async (): Promise<ApiResponse<SiteDropdownItem[]>> => {
    try {
      const res = await api.get<SiteDropdownItem[]>('/sites/dropdown');
      if (res.success) return res;
    } catch {}
    const all = await siteService.getAll(true);
    if (all.success && all.data) {
      return {
        success: true,
        data: all.data.map(s => ({ id: s.id ?? s.siteID!, name: s.name, code: s.code })),
      };
    }
    return { success: false, data: [] } as any;
  },

  getById: async (id: number): Promise<ApiResponse<Site>> => {
    return api.get(`/sites/${id}`);
  },

  create: async (data: SiteCreateDto): Promise<ApiResponse<{ id: number }>> => {
    return api.post('/sites', data);
  },

  update: async (id: number, data: SiteUpdateDto): Promise<ApiResponse<{ id: number }>> => {
    return api.put(`/sites/${id}`, data);
  },

  delete: async (id: number): Promise<ApiResponse<{ id: number }>> => {
    return api.delete(`/sites/${id}`);
  },
};

export default siteService;
